import { render, staticRenderFns } from "./RoomMenu.vue?vue&type=template&id=d5796b56&"
import script from "./RoomMenu.vue?vue&type=script&lang=js&"
export * from "./RoomMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports